import type { SVGProps } from "react";
export interface SolarPanelIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function SolarPanelIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: SolarPanelIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M17.532 12.375c1.04 0 1.983.613 2.404 1.565l3.05 6.903.074.204a1.626 1.626 0 0 1-1.561 2.078H2.5a1.626 1.626 0 0 1-1.487-2.282l3.051-6.903.085-.175a2.63 2.63 0 0 1 2.32-1.39h11.062Zm-4.406 8.5h7.413l-.883-2h-6.53zm-9.666 0h7.416v-2H4.344zm9.666-4.25h5.535l-.784-1.776a.38.38 0 0 0-.345-.224h-4.406zm-6.657-2a.38.38 0 0 0-.288.132l-.058.092-.785 1.776h5.538v-2zM5.25 8.375l.114.006a1.125 1.125 0 0 1 0 2.239l-.114.006H4.5a1.125 1.125 0 0 1 0-2.25h.75ZM14.126 9.5a2.126 2.126 0 0 0-4.252 0 1.125 1.125 0 0 1-2.25 0 4.376 4.376 0 0 1 8.752 0 1.126 1.126 0 0 1-2.25 0m4.623 1.126a1.125 1.125 0 0 1 .001-2.25zm.752-2.25a1.126 1.126 0 0 1-.001 2.25h-.752L18.75 9.5V8.375zm-2.994-4.974a1.125 1.125 0 1 1 1.591 1.591l-.53.53a1.126 1.126 0 0 1-1.591-1.59zm-10.605 0a1.124 1.124 0 0 1 1.504-.077l.087.077.528.53.078.086A1.124 1.124 0 0 1 6.517 5.6l-.086-.078-.53-.529-.077-.086a1.124 1.124 0 0 1 .078-1.505M10.875 2a1.125 1.125 0 0 1 2.25 0v.75l-.006.115a1.126 1.126 0 0 1-2.244-.116z"
      />
    </svg>
  );
}
